import { AnimateIcon } from '@/components/animate-ui/icons/icon';
import { LoaderPinwheel } from '@/components/animate-ui/icons/loader-pinwheel';

interface SiteBrandLinkProps {
  onClick?: () => void;
  /** Defaults to nav wordmark (`text-body-md`). Footer uses `body`. */
  wordmarkPreset?: 'body' | 'body-md';
  /** Footer shows the logo mark only. */
  showWordmark?: boolean;
}

export function SiteBrandLink({
  onClick,
  wordmarkPreset = 'body-md',
  showWordmark = true,
}: SiteBrandLinkProps) {
  const wordmarkClass = wordmarkPreset === 'body' ? 'text-body' : 'text-body-md';

  return (
    <AnimateIcon animateOnHover asChild>
      <a
        href="/"
        className="flex shrink-0 items-center gap-2 text-text-primary"
        onClick={onClick}
        aria-label={showWordmark ? undefined : 'Arvid home'}
      >
        <LoaderPinwheel size={24} />
        {showWordmark ? <span className={wordmarkClass}>Arvid</span> : null}
      </a>
    </AnimateIcon>
  );
}
